
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recruit/jobs/[city]",
      function () {
        return require("private-next-pages/recruit/jobs/[city]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recruit/jobs/[city]"])
      });
    }
  